export default "__VITE_ASSET__23b66953__"